import { FrownOutlined } from '@ant-design/icons';
import {
    type ErrorComponentProps,
    Link,
    SearchParamError,
    useLocation,
} from '@tanstack/react-router';
import { Button } from 'antd';
import { useMemo } from 'react';
import { z } from 'zod';
import { NotFoundPage } from './NotFoundPage';

function isPathParamError(error: unknown) {
    return (
        error instanceof Error &&
        !(error instanceof SearchParamError) &&
        error.cause instanceof z.ZodError
    );
}

export function DefaultErrorComponent({ error }: ErrorComponentProps) {
    const location = useLocation();

    const erro = useMemo(() => {
        if (error instanceof z.ZodError) {
            return z.prettifyError(error);
        }

        if (error instanceof Error) {
            return error.message;
        }

        return String(error);
    }, [error]);

    if (isPathParamError(error)) {
        return <NotFoundPage />;
    }

    const isAdmin = location.pathname.includes('/admin');

    return (
        <div className='container mb-auto pl-5 pr-5 pt-10 text-black'>
            <div className='mb-3' style={{ alignItems: 'start', display: 'flex' }}>
                <p className='mb-3 text-4xl font-bold'>Ops!</p>
                <FrownOutlined className='pt-2 text-4xl' style={{ marginLeft: 10 }} />
            </div>

            <div className='text-2xl text-gray-500'>
                Um erro inesperado aconteceu e não foi possível exibir esta página.
            </div>

            <div
                style={{
                    backgroundColor: 'rgba(250, 250, 250, 0.7)',
                    border: '2px solid #eaeaea',
                    borderRadius: 5,
                    margin: '50px 0px',
                    padding: 40,
                    width: '100%',
                }}
            >
                <p className='text-2xl font-bold'>Descrição do problema:</p>
                <p className='text-base text-gray-500'>{erro}</p>
            </div>

            <Link to={isAdmin ? '/admin' : '/'}>
                <Button>Voltar para a página inicial</Button>
            </Link>
        </div>
    );
}
